import { render, staticRenderFns } from "./VehicleAutocomplete.vue?vue&type=template&id=5dd79050&scoped=true"
import script from "./VehicleAutocomplete.vue?vue&type=script&lang=ts"
export * from "./VehicleAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd79050",
  null
  
)

export default component.exports